var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('div',{staticClass:"mt-2"},[_c('input',{ref:"imageInput",staticStyle:{"display":"none"},attrs:{"id":`imageInput_${_vm.idx}`,"type":"file","accept":_vm.mimeTypes},on:{"change":_vm.loadFileFromInput}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }